import { render, staticRenderFns } from "./MaterialBatch.vue?vue&type=template&id=3f005e03&scoped=true"
import script from "./MaterialBatch.vue?vue&type=script&lang=js"
export * from "./MaterialBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f005e03",
  null
  
)

export default component.exports